import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { verifyFundingPayment } from "../../redux/Actions/walletAction";
import { getWalletReducer } from "../../redux/Reducer/walletReducer";
import { Result, Button, Spin, Card } from "antd";

const VerifyWalletFunding = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  const { isVerifyingPayment, verificationData } =
    useSelector(getWalletReducer);

  // 👉 1. LOCK IN VALUES ON FIRST RENDER (Using useState lazy initialization)
  const [gateway] = useState(() => {
    return searchParams.get("gateway") || "opay";
  });

  const [reference] = useState(() => {
    return (
      searchParams.get("reference") ||
      searchParams.get("trxref") ||
      searchParams.get("orderNo") ||
      searchParams.get("transaction_id") ||
      localStorage.getItem("wallet_funding_ref")
    ); // Fallback to storage
  });

  useEffect(() => {
    // Only dispatch if we have the data and haven't fetched yet
    if (reference && gateway && !hasFetched.current) {
      hasFetched.current = true;

      // Dispatch exact payload to Backend
      dispatch(
        verifyFundingPayment({
          reference: reference,
          gateway: gateway,
        }),
      );

      // Safe to clean up storage now because React is holding 'reference' in state!
      localStorage.removeItem("wallet_funding_ref");
    }
  }, [reference, gateway, dispatch]);

  const handleDone = () => {
    navigate("/dashboard");
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#F8F9FD",
      }}
    >
      <Card
        style={{
          width: 400,
          borderRadius: 12,
          textAlign: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        {!reference ? (
          <Result
            status="warning"
            title="Invalid Request"
            subTitle="Missing transaction reference. We cannot verify this transaction."
            extra={[
              <Button
                type="primary"
                size="large"
                key="dashboard"
                onClick={handleDone}
                style={{ backgroundColor: "#252A4D", width: "100%" }}
              >
                Back to Dashboard
              </Button>,
            ]}
          />
        ) : isVerifyingPayment ||
          (!verificationData?.status && !verificationData?.message) ? (
          <div style={{ padding: "40px 0" }}>
            <Spin size="large" />
            <h3 className="mt-4" style={{ color: "#252A4D" }}>
              Verifying Payment...
            </h3>
            <p style={{ color: "#888", fontSize: "13px" }}>
              Please do not close or refresh this window.
            </p>
          </div>
        ) : verificationData?.status === true ? (
          <Result
            status="success"
            title="Wallet Funded Successfully!"
            subTitle={
              verificationData.message ||
              "Your account balance has been updated."
            }
            extra={[
              <Button
                type="primary"
                size="large"
                key="dashboard"
                onClick={handleDone}
                style={{ backgroundColor: "#252A4D", width: "100%" }}
              >
                Continue to Dashboard
              </Button>,
            ]}
          />
        ) : (
          <Result
            status="error"
            title="Verification Failed"
            subTitle={
              verificationData?.message ||
              "We couldn't verify your payment. If you were debited, please contact support."
            }
            extra={[
              <Button
                type="primary"
                size="large"
                key="dashboard"
                onClick={handleDone}
                style={{ backgroundColor: "#252A4D", width: "100%" }}
              >
                Back to Dashboard
              </Button>,
            ]}
          />
        )}
      </Card>
    </div>
  );
};

export default VerifyWalletFunding;
